import React, { createContext, useMemo } from 'react';
/**
 * Context that allows to share common Badge Preview logic
 *
 * * usage is optional
 */
export const BadgePreviewContext = createContext({});
/**
 * Context that allows to share common Badge Preview logic
 *
 * * usage is optional
 */
export const BadgePreviewContextProvider = ({ children, onGetDataForBadgeTemplateImageGeneration, }) => {
    const state = useMemo(() => ({
        onGetDataForBadgeTemplateImageGeneration: onGetDataForBadgeTemplateImageGeneration,
    }), [onGetDataForBadgeTemplateImageGeneration]);
    return React.createElement(BadgePreviewContext.Provider, { value: state }, children);
};
